import { MenuIcon, EchartIcon, AvatarIcon } from "../icons";
import { clsx } from "clsx";
import { IUser} from "pages/meter/types"
export type DataType = "List" | "Chart";
import { FormattedMessage } from "react-intl";

type IProps = {
  user?: IUser;
  dataType: DataType;
  onChange: (dataType: DataType) => void;
};

export const Header = ({ dataType,user, onChange }: IProps) => {
  return (
    <div className="h-[132px] md:h-[130px] lg:h-[210px] xl:h-[150px] w-full bg-primary pt-[21px] lg:pt-10 py-[12px] px-4 md:px-10">
      <div className="flex items-center justify-between">
        <div className="flex flex-1 gap-[10px] md:gap-[20px] lg:gap-[40px]">
          <div
            onClick={() => onChange("Chart")}
            className={clsx(
              "border border-solid border-white rounded-[84px] h-[28px] flex items-center justify-center cursor-pointer w-[80px] md:w-[110px] md:h-[36px] lg:w-[162px] lg:h-[54px]",
              {
                "bg-white text-primary": dataType === "Chart",
                "bg-primary text-white": dataType !== "Chart",
              }
            )}
          >
            <div className="mr-[8px] flex items-center justify-center">
              <EchartIcon className="w-[18px] h-[18px] lg:w-[36px] lg:h-[36px]" />
            </div>
            <span className="text-sm md:text-base lg:text-xl">
              <FormattedMessage id="meter.share.chart" />
            </span>
          </div>
          <div
            onClick={() => onChange("List")}
            className={clsx(
              "border border-solid border-white rounded-[84px] h-[28px] flex items-center justify-center cursor-pointer w-[80px] md:w-[110px] md:h-[36px] lg:w-[162px] lg:h-[54px]",
              {
                "bg-white text-primary": dataType === "List",
                "bg-primary text-white": dataType !== "List",
              }
            )}
          >
            <div className="mr-[8px] flex items-center justify-center">
              <MenuIcon className="w-[18px] h-[18px] lg:w-[36px] lg:h-[36px]" />
            </div>
            <span className="text-sm md:text-base lg:text-xl">
              <FormattedMessage id="meter.share.list" />
            </span>
          </div>
        </div>
        <div className="flex items-center text-white">
          <div className="mr-[8px] w-[32px] h-[32px] lg:w-[64px] lg:h-[64px] flex items-center justify-center">
            <AvatarIcon />
          </div>
          <span className="max-w-[80px] lg:max-w-[140px] lg:text-lg inline-block overflow-hidden text-ellipsis whitespace-nowrap">
            {user?.name}
          </span>
        </div>
      </div>
    </div>
  );
};
